export const Translations: Record<string, Record<string, string>> = {}
export const LabelIds: string[] = []
export const Languages: Record<string, string> = {}
export type TType = Record<(typeof LabelIds)[number], string>
